/* wishlist.js  – keyed by productHandle */

document.addEventListener("DOMContentLoaded", () => {
  /* ───────── constants ───────── */
  const SELECTORS = {
    addBtn: ".wishlist_button",
    block: ".js-wishlistBlock",
    heartBox: ".user-menu-box__header-heart-icon",
    removeBtn: ".wishlist_button_remove",
    cardSel: ".card--product", // class on rendered card
    section: "ws_card-render",
  };

  /* ───────── storage service ───────── */
  const Storage = {
    key: "wishlist",
    load() {
      return JSON.parse(localStorage.getItem(this.key) || "[]");
    },
    save(data) {
      localStorage.setItem(this.key, JSON.stringify(data));
    },
  };

  /* ───────── dom shorthands ───────── */
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];

  /* ───────── Wishlist class ───────── */
  class Wishlist {
    constructor() {
      this.data = Storage.load(); // [{handle, …}, …]
      this.block = $(SELECTORS.block);
      this.counter = $(SELECTORS.heartBox);
      this.bindAddButtons();
      this.render();
      this.updateCounter();
    }

    /* public ---------------------------------------------------------- */
    toggle(item) {
      const idx = this.data.findIndex(
        (i) => i.productHandle === item.productHandle
      );
      idx === -1 ? this.data.push(item) : this.data.splice(idx, 1);
      Storage.save(this.data);
      this.updateHeartIcon(item.productTitle);
      this.updateCounter();
      this.render();
    }

    remove(handle, clickedBtn = null, title) {
      this.data = this.data.filter((i) => i.productHandle !== handle);
      Storage.save(this.data);
      this.updateHeartIcon(title);
      this.updateCounter();

      /* remove single card */
      let card = $(
        `${SELECTORS.cardSel}[data-product-handle="${CSS.escape(handle)}"]`
      );
      if (!card && clickedBtn) card = clickedBtn.closest(SELECTORS.cardSel);
      if (!card) return;

      document.startViewTransition
  ? document.startViewTransition(() => card.parentElement.remove())
  : card.parentElement.remove();

      if (this.data.length === 0) this.clearBlock();
    }

    /* internal -------------------------------------------------------- */
    bindAddButtons() {
      $$(SELECTORS.addBtn).forEach((btn) => {
        btn.addEventListener("click", () => {
          const item = {
            productHandle: btn.dataset.productHandle,
            productTitle: btn.dataset.productTitle,
            productImg: btn.dataset.img,
            productPrice: btn.dataset.price,
            productComp: btn.dataset.compare,
            productUrl: btn.dataset.url,
            productHandle: btn.dataset.handle,
          };
          this.toggle(item);
        });
        this.updateHeartIcon(btn.dataset.productTitle);
      });
    }

    updateHeartIcon(title) {
    const btnselector = `${SELECTORS.addBtn}[data-product-Title='${title}']`;
      const btn = $(btnselector);
      if (!btn) return;
      const inList = this.data.some((i) => i.productTitle === title);
      btn.classList.toggle("active", inList);
      btn.innerHTML = inList ? Wishlist.icons.filled : Wishlist.icons.outline;
    }

    updateCounter() {
      if (!this.counter) return;
      this.counter.innerHTML = this.data.length
        ? `<span class="user-menu-box__header-heart-icon-inner">${this.data.length}</span>`
        : "<span></span>";
    }

    clearBlock() {
      this.block && (this.block.innerHTML = "");
    }

    render() {
      if (!this.block) return console.error("Wishlist block not found");
      this.clearBlock();
      if (!this.data.length) return;

      this.data.forEach((item) => this.appendCard(item));
    }

    appendCard(item) {
      const url = `${window.Shopify.routes.root}products/${item.productHandle}?sections=${SELECTORS.section}`;

      fetch(url)
        .then((r) => r.json())
        .then((j) => {
          const html = j[SELECTORS.section];
          if (!html) return;
          const card = new DOMParser().parseFromString(html, "text/html").body
            .firstElementChild;
          card.dataset.productHandle = item.productHandle;

          const rm = $(SELECTORS.removeBtn, card);
          if (rm) {
            rm.dataset.productHandle = item.productHandle;
            rm.addEventListener("click", (e) =>
              this.remove(item.productHandle, e.currentTarget, item.productTitle)
            );
          }
          this.block.appendChild(card);
        })
        .catch(console.error);
    }

    /* icons ----------------------------------------------------------- */
    static get icons() {
      return {
        filled:
          '<svg class="heart-filled" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.498 12.053 12.125 21l8.627-8.947a5.405 5.405 0 0 0 1.498-3.75C22.25 5.374 19.96 3 17.136 3a5.023 5.023 0 0 0-3.616 1.553L12.125 6 10.73 4.553A5.023 5.023 0 0 0 7.114 3C4.29 3 2 5.374 2 8.303c0 1.407.539 2.756 1.498 3.75Z" stroke="#EA4112" fill="#EA4112" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        outline:
          '<svg class="heart-outline" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.498 12.053 12.125 21l8.627-8.947a5.405 5.405 0 0 0 1.498-3.75C22.25 5.374 19.96 3 17.136 3a5.023 5.023 0 0 0-3.616 1.553L12.125 6 10.73 4.553A5.023 5.023 0 0 0 7.114 3C4.29 3 2 5.374 2 8.303c0 1.407.539 2.756 1.498 3.75Z" stroke="#1C1C1C" fill="none" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      };
    }
  }

  /* ───────── bootstrap ───────── */
  new Wishlist();
});
